import { render, staticRenderFns } from "./TomaReception.vue?vue&type=template&id=31a453ff"
import script from "./TomaReception.vue?vue&type=script&lang=js"
export * from "./TomaReception.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports